<template>
    <div class="main">
        <div v-if="!turmaId" class="u-text-center u-mt-20">
            Nenhuma turma selecionada.
        </div>

        <div v-else>
            <el-form label-position="top">

                <c-panel title="Identificação">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Título" key="ape_titulo">
                                <el-input v-model="avaliacaoPreEscolaTemplate.titulo" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Versão" key="ape_version">
                                <el-input v-model="avaliacaoPreEscolaTemplate.version" v-mask="'####'" @blur="toIntTemplate('version')"></el-input>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>
                </c-panel>
                
                <c-panel title="Conceitos">
                    <el-row :gutter="10" class="u-mt-10">
                        <el-col :xs="24" :sm="24" :md="24">
                            
                            <div class="container-table">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th style="width: 90px;">Sigla</th>
                                            <th style="width: 80px;" class="u-text-center">Ordem</th>
                                            <th style="width: 70px;" class="u-text-center">Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(c, i) in avaliacaoPreEscolaTemplate.conceitos" :key="c.id">
                                            <td><el-input v-model="c.nome" placeholder="Ex.: BOM"></el-input></td>
                                            <td><el-input v-model="c.sigla" placeholder="Ex.: B"></el-input></td>
                                            <td><el-input v-model="c.ordem" v-mask="'####'" @blur="toIntConceito(i)"></el-input></td>
                                            <td class="u-text-center">
                                                <el-button type="danger" plain icon="el-icon-delete" size="mini" @click="removeConceito(i)"></el-button>
                                            </td>
                                        </tr>
                                        <tr v-if="avaliacaoPreEscolaTemplate.conceitos.length === 0">
                                            <td colspan="5" class="u-text-center">Nenhum conceito cadastrado.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="u-text-right u-mt-10">
                                <el-button type="primary" plain @click="addConceito">
                                    <i class="fas fa-plus"></i> ADICIONAR CONCEITO
                                </el-button>
                            </div>

                        </el-col>
                    </el-row>
                </c-panel>

                <c-panel title="Categorias">
                    <el-row :gutter="10" class="u-mt-10">
                        <el-col :xs="24" :sm="24" :md="24">
                            
                            <div v-if="avaliacaoPreEscolaTemplate.categorias.length === 0" class="u-text-center u-mt-10">
                                Nenhuma categoria cadastrada.
                            </div>

                            <el-collapse v-else>
                                <el-collapse-item v-for="(cat, ci) in avaliacaoPreEscolaTemplate.categorias" :key="cat.id" :title="`${cat.ordem || ''} - ${cat.nome || 'Categoria sem nome'}`" :name="cat.id">
                                    <el-row :gutter="10">
                                        <el-col :xs="24" :sm="16" :md="16">
                                            <el-form-item label="Nome da categoria" :key="`cat_nome_${cat.id}`">
                                                <el-input v-model="cat.nome" maxlength="191"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="4" :md="4">
                                            <el-form-item label="Ordem" :key="`cat_ordem_${cat.id}`">
                                                <el-input v-model="cat.ordem" v-mask="'####'" @blur="toIntCategoria(ci)"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="4" :md="4" class="u-text-right">
                                            <el-button type="danger" plain @click="removeCategoria(ci)" style="margin-top: 21px;">
                                                <i class="fas fa-trash-alt"></i>
                                            </el-button>
                                        </el-col>
                                    </el-row>

                                    <div class="u-text-right u-mb-10">
                                        <el-button type="primary" plain size="small" @click="addPergunta(ci)">
                                            <i class="fas fa-plus"></i> ADICIONAR PERGUNTA
                                        </el-button>
                                    </div>

                                    <div class="container-table">
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Enunciado</th>
                                                    <th style="width: 150px;" class="u-text-center">Tipo</th>
                                                    <th style="width: 90px;" class="u-text-center">Ordem</th>
                                                    <th style="width: 120px;" class="u-text-center">Obrigatória</th>
                                                    <th style="width: 70px;" class="u-text-center">Ação</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(p, pi) in cat.perguntas" :key="p.id">
                                                    <td><el-input v-model="p.enunciado" placeholder="Digite a pergunta"></el-input></td>
                                                    <td class="u-text-center">
                                                        <el-select v-model="p.tipo" style="width: 150px;">
                                                            <el-option key="OBJETIVA" label="OBJETIVA" value="OBJETIVA"></el-option>
                                                            <el-option key="DISSERTATIVA" label="DISSERTATIVA" value="DISSERTATIVA"></el-option>
                                                        </el-select>
                                                    </td>
                                                    <td><el-input v-model="p.ordem" v-mask="'####'" @blur="toIntPergunta(ci, pi)"></el-input></td>
                                                    <td class="u-text-center">
                                                        <el-select v-model="p.obrigatoria" style="width: 120px;">
                                                            <el-option :key="true" label="SIM" :value="true"></el-option>
                                                            <el-option :key="false" label="NÃO" :value="false"></el-option>
                                                        </el-select>
                                                    </td>
                                                    <td class="u-text-center">
                                                        <el-button type="danger" plain icon="el-icon-delete" size="mini" @click="removePergunta(ci, pi)"></el-button>
                                                    </td>
                                                </tr>
                                                <tr v-if="!cat.perguntas || cat.perguntas.length === 0">
                                                    <td colspan="5" class="u-text-center">Nenhuma pergunta nesta categoria.</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>

                            <div class="u-text-right u-mt-10">
                                <el-button type="primary" plain @click="addCategoria">
                                    <i class="fas fa-plus"></i> ADICIONAR CATEGORIA
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>
                </c-panel>
                
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <div class="u-text-right u-mt-15">
                            <el-button :loading="loadingTemplate" @click="loadAvaliacaoPreEscolaTemplate" plain>
                                LIMPAR FORMULÁRIO
                            </el-button>
                            <el-button size="small" type="danger" @click="$emit('close')">
                                CANCELAR
                            </el-button>
                            <el-button type="primary" :loading="savingTemplate" @click="saveAvaliacaoPreEscolaTemplate">
                                SALVAR
                            </el-button>                            
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    props: ['turmaId'],
    data: () => ({
        loadingTemplate: false,
        savingTemplate: false,
        avaliacaoPreEscolaTemplate: {
            version: 1,
            titulo: '',
            conceitos: [],
            categorias: []
        },
    }),
    mounted(){
        this.loadAvaliacaoPreEscolaTemplate();
    },
    methods:{
        normalizeTemplate(template){
            const tpl = template && typeof template === 'object' ? template : {};
            const categorias = Array.isArray(tpl.categorias) ? tpl.categorias : [];
            const categoriasNorm = categorias.map((cat) => {
                const perguntas = Array.isArray(cat.perguntas) ? cat.perguntas : [];
                return {
                    ...cat,
                    perguntas: perguntas.map((p) => ({
                        ...p,
                        tipo: p.tipo || 'OBJETIVA',
                        obrigatoria: typeof p.obrigatoria === 'boolean' ? p.obrigatoria : !!p.obrigatoria,
                    }))
                }
            });

            return {
                version: tpl.version || 1,
                titulo: tpl.titulo || '',
                conceitos: Array.isArray(tpl.conceitos) ? tpl.conceitos : [],
                categorias: categoriasNorm,
            }
        },
        generateLocalId(prefix = 'id'){
            return `${prefix}_${Date.now()}_${Math.floor(Math.random() * 100000)}`;
        },
        async loadAvaliacaoPreEscolaTemplate(){
            if(!this.turmaId) return;
            this.loadingTemplate = true;
            try{
                const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAvaliacaoPreEscolaTemplate/` + this.turmaId, this.$store.getters.getHeaderAuth);
                if(res.data && res.data.throw){
                    window.eventBus.$emit('alert', {msg: res.data.throw.msg, type: res.data.throw.type});
                }else{
                    this.avaliacaoPreEscolaTemplate = this.normalizeTemplate(res.data.template);
                }
            }catch(error){
                this.$store.commit('throwException', error);
            }finally{
                this.loadingTemplate = false;
            }
        },
        async saveAvaliacaoPreEscolaTemplate(){
            if(!this.turmaId) return;
            this.savingTemplate = true;
            try{
                const payload = JSON.parse(JSON.stringify(this.avaliacaoPreEscolaTemplate));
                const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/storeAvaliacaoPreEscolaTemplate/` + this.turmaId, payload, this.$store.getters.getHeaderAuth);
                if(res.data && res.data.throw){
                    window.eventBus.$emit('alert', {msg: res.data.throw.msg, type: res.data.throw.type});
                }else{
                    this.avaliacaoPreEscolaTemplate = this.normalizeTemplate(res.data.template);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Template salvo com sucesso.', type: 'success'});
                    $emit('close')
                }
            }catch(error){
                this.$store.commit('throwException', error);
            }finally{
                this.savingTemplate = false;
            }
        },
        toIntTemplate(field){
            if(this.avaliacaoPreEscolaTemplate[field] === '' || this.avaliacaoPreEscolaTemplate[field] === null) return;
            this.avaliacaoPreEscolaTemplate[field] = parseInt(this.avaliacaoPreEscolaTemplate[field]);
        },
        addConceito(){
            this.avaliacaoPreEscolaTemplate.conceitos.push({ id: this.generateLocalId('c'), nome: '', sigla: '', ordem: (this.avaliacaoPreEscolaTemplate.conceitos.length + 1), cor: '#CCCCCC' });
        },
        removeConceito(i){
            this.avaliacaoPreEscolaTemplate.conceitos.splice(i, 1);
        },
        toIntConceito(i){
            if(this.avaliacaoPreEscolaTemplate.conceitos[i] && this.avaliacaoPreEscolaTemplate.conceitos[i].ordem !== '' && this.avaliacaoPreEscolaTemplate.conceitos[i].ordem !== null)
                this.avaliacaoPreEscolaTemplate.conceitos[i].ordem = parseInt(this.avaliacaoPreEscolaTemplate.conceitos[i].ordem);
        },
        addCategoria(){
            this.avaliacaoPreEscolaTemplate.categorias.push({ id: this.generateLocalId('cat'), nome: '', ordem: (this.avaliacaoPreEscolaTemplate.categorias.length + 1), perguntas: [] });
        },
        removeCategoria(i){
            this.avaliacaoPreEscolaTemplate.categorias.splice(i, 1);
        },
        toIntCategoria(i){
            if(this.avaliacaoPreEscolaTemplate.categorias[i] && this.avaliacaoPreEscolaTemplate.categorias[i].ordem !== '' && this.avaliacaoPreEscolaTemplate.categorias[i].ordem !== null)
                this.avaliacaoPreEscolaTemplate.categorias[i].ordem = parseInt(this.avaliacaoPreEscolaTemplate.categorias[i].ordem);
        },
        addPergunta(catIndex){
            if(!this.avaliacaoPreEscolaTemplate.categorias[catIndex].perguntas)
                this.avaliacaoPreEscolaTemplate.categorias[catIndex].perguntas = [];
            this.avaliacaoPreEscolaTemplate.categorias[catIndex].perguntas.push({
                id: this.generateLocalId('p'),
                enunciado: '',
                tipo: 'OBJETIVA',
                ordem: (this.avaliacaoPreEscolaTemplate.categorias[catIndex].perguntas.length + 1),
                obrigatoria: true
            });
        },
        removePergunta(catIndex, perguntaIndex){
            this.avaliacaoPreEscolaTemplate.categorias[catIndex].perguntas.splice(perguntaIndex, 1);
        },
        toIntPergunta(catIndex, perguntaIndex){
            const p = this.avaliacaoPreEscolaTemplate.categorias[catIndex].perguntas[perguntaIndex];
            if(p && p.ordem !== '' && p.ordem !== null) p.ordem = parseInt(p.ordem);
        },
    },
    watch:{
        turmaId:{
            immediate: true,
            handler(){
                this.loadAvaliacaoPreEscolaTemplate();
            }
        }
    }
}
</script>

